/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppRouter, getRouteInitData } from '@gh/common-shared';
import { RouteDataService, SlicedDataSource } from '@gh/core-data';
import {
  cursorTracker,
  GridDefinitionFactory,
  GridRowEvent,
  LayoutBasedGridDefinition,
  newGridPaginationCursor,
} from '@gh/core-ui-grid';
import { MasterZone } from '../../resources/master-zone.model';
import { OfficePermissionsMasterZoneListBusinessService } from '../../resources/office-permissions-master-zone-list-business.service';

@Component({
  selector: 'gh-office-permissions-master-zone-list',
  template: require('./office-permissions-master-zone-list.component.html'),
  styles: [require('./office-permissions-master-zone-list.component.scss')],
  viewProviders: [GridDefinitionFactory],
})
export class OfficePermissionsMasterZoneListComponent implements OnInit {
  dataSource: SlicedDataSource<MasterZone>;
  cursor = newGridPaginationCursor();
  gridDefinition: LayoutBasedGridDefinition;

  constructor(private router: AppRouter,
              private route: ActivatedRoute,
              private routeData: RouteDataService,
              private businessService: OfficePermissionsMasterZoneListBusinessService,
              private gridDefinitionFactory: GridDefinitionFactory) {
    this.gridDefinition = this.gridDefinitionFactory.buildLayoutBased({}, {
      getRowNodeId: (data: MasterZone) => data.id,
    });
  }

  ngOnInit(): void {
    const { gridLayout } = getRouteInitData(this.route);

    this.gridDefinition.bind(gridLayout);

    const tracker = this.routeData.tracker().withEffects(cursorTracker(this.cursor));
    tracker.listen(this.route);
    tracker.filterChanges.subscribe(() => {
      this.dataSource = this.businessService.findAllMasterZonesAsDataSource();
    });
  }

  onMasterZoneSelect(event: GridRowEvent<MasterZone>): void {
    this.router.navigateToChild(['setup/office-permissions', event.data.id]);
  }
}
